import { List } from '@mui/material';
import { useExtendedIntl } from 'hooks/useExtendedIntl';
import { FunctionComponent, PropsWithChildren } from 'react';
import { FetchMoreWrapper } from 'shared/FetchMoreWrapper';
import { ProgressButton } from 'shared/ProgressButtons/ProgressButton';
import { TeamUser } from 'shared/TeamForm/types';
import { TeamUserListItem } from './TeamUserListItem';

interface TeamUsersListProps {
  canEdit?: boolean;
  hasMore?: boolean;
  teamOwner: TeamUser;
  teamUsers: TeamUser[];
  fetchMore?: () => void;
  fetchingMore?: boolean;
  handleMakeAdmin: (owner: TeamUser) => void;
  handleDeleteTeamUser: (owner: TeamUser) => void;
}

export const TeamUsersList: FunctionComponent<PropsWithChildren<TeamUsersListProps>> = ({
  teamOwner,
  teamUsers,
  fetchMore,
  canEdit = false,
  hasMore = false,
  handleMakeAdmin,
  fetchingMore = false,
  handleDeleteTeamUser,
}) => {
  const { formatMessage } = useExtendedIntl();

  return (
    <List
      sx={(theme) => ({ overflowY: 'auto', maxHeight: '15rem', [theme.breakpoints.up('sm')]: { maxHeight: '15rem' } })}
    >
      <TeamUserListItem
        isAdmin
        key={teamOwner.id}
        teamUser={teamOwner}
        handleMakeAdmin={handleMakeAdmin}
        handleDeleteTeamUser={handleDeleteTeamUser}
      />
      {teamUsers.map((teamUser) => (
        <TeamUserListItem
          canEdit={canEdit}
          key={teamUser.id}
          teamUser={teamUser}
          handleMakeAdmin={handleMakeAdmin}
          handleDeleteTeamUser={handleDeleteTeamUser}
        />
      ))}
      {hasMore && (
        <FetchMoreWrapper>
          <ProgressButton variant="text" onClick={fetchMore} loading={fetchingMore}>
            {formatMessage({ id: 'shared.load-more' })}
          </ProgressButton>
        </FetchMoreWrapper>
      )}
    </List>
  );
};
